module.exports = __webpack_public_path__ + "img/empty_list_view.3a0f14c9.png";